export default "__VITE_ASSET__GOU0zVtb__"